import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierSignUp.components.Form.title',
    defaultMessage: 'Ready to become a part of VoiceArchive?',
  },
  subtitle: {
    id: 'containers.SupplierSignUp.components.Form.subtitle',
    defaultMessage: 'Let’s start with the introductions.\n\nIf you\'re experiencing trouble with the site, please select Chrome as your browser.',
  },
  validationFailed: {
    id: 'containers.SupplierSignUp.components.Form.validationFailed',
    defaultMessage: 'Please make sure you have filled out the form correctly.',
  },
  emailLabel: {
    id: 'containers.SupplierSignUp.components.Form.email.label',
    defaultMessage: 'What\'s your e-mail?',
  },
  emailPlaceholder: {
    id: 'containers.SupplierSignUp.components.Form.email.placeholder',
    defaultMessage: 'your@mail.com',
  },
  passwordLabel: {
    id: 'containers.SupplierSignUp.components.Form.password.label',
    defaultMessage: 'Choose a secure password',
  },
  passwordLabelHint: {
    id: 'containers.SupplierSignUp.components.Form.password.label.hint',
    defaultMessage: 'The password must have at least 12 characters',
  },
  passwordPlaceholder: {
    id: 'containers.SupplierSignUp.components.Form.password.placeholder',
    defaultMessage: 'VeryLong&SecurePassw0rd',
  },
  applicationLabel: {
    id: 'containers.SupplierSignUp.components.Form.application.label',
    defaultMessage: 'Tell us a little about your experience in the voice over industry, and why you want to join VoiceArchive',
  },
  applicationPlaceholder: {
    id: 'containers.SupplierSignUp.components.Form.application.placeholder',
    defaultMessage: 'Type your answer here',
  },
  applicationHint: {
    id: 'containers.SupplierSignUp.components.Form.application.hint',
    defaultMessage: '{left} characters left of {max}. Min. characters is {min}.',
  },
  refererLabel: {
    id: 'containers.SupplierSignUp.components.Form.referer.label',
    defaultMessage: 'How did you hear about us?',
  },
  refererLabelHint: {
    id: 'containers.SupplierSignUp.components.Form.referer.label.hint',
    defaultMessage: 'Please let us know how did you hear about us.',
  },
  apply: {
    id: 'containers.SupplierSignUp.components.Form.apply',
    defaultMessage: 'Apply',
  },
  refererSearch: {
    id: 'containers.SupplierSignUp.components.Form.referer.search',
    defaultMessage: 'Search (Google, Bing, etc.)',
  },
  refererSoMe: {
    id: 'containers.SupplierSignUp.components.Form.referer.some',
    defaultMessage: 'Facebook, LinkedIn, etc.',
  },
  refererOffline: {
    id: 'containers.SupplierSignUp.components.Form.referer.offline',
    defaultMessage: 'Offline event',
  },
  refererFriend: {
    id: 'containers.SupplierSignUp.components.Form.referer.friend',
    defaultMessage: 'Friend/colleague',
  },
  refererOther: {
    id: 'containers.SupplierSignUp.components.Form.referer.other',
    defaultMessage: 'Other',
  },
  refererNotePlaceholder: {
    id: 'containers.SupplierSignUp.components.Form.referer.note.placeholder',
    defaultMessage: 'Where?',
  },
  loading: {
    id: 'containers.SupplierSignUp.components.Form.loading',
    defaultMessage: 'Loading ',
  },
  logoSrc: {
    id: 'containers.SupplierSignUp.components.Form.logoSrc',
    defaultMessage: 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/small-curve-white.svg',
  },
})
